import {
  useMarketingControllerGetMarketingConsents,
  useMarketingControllerUpdateMarketingConsents,
} from '@docnboard/rest';

/**
 * @deprecated
 */
export const useMarketingConsent = useMarketingControllerGetMarketingConsents;

/**
 * @deprecated
 */
export const useUpdateMarketingConsent =
  useMarketingControllerUpdateMarketingConsents;
